import {useState, useRef, useEffect} from 'react';
import { cn } from '@/lib/utils';

export default function ResponsiveImage({src, alt, srcSet, className, width, height, loading = 'eager'}) {
    const [sizes, setSizes] = useState('1px');
    const imageRef = useRef(null);

    useEffect(() => {
        if (!imageRef.current) {
            return;
        }

        const width = imageRef.current.getBoundingClientRect().width;
        const newSize = Math.ceil(width/window.innerWidth*100)+'vw';
        setSizes(newSize);
    }, [])

    return (
        <img
            loading={loading}
            ref={imageRef}
            className={cn('object-contain', className)}
            srcSet={srcSet}
            sizes={sizes}
            src={src}
            width={width}
            height={height}
            alt={alt}
        />
    )
}
